import React from 'react';
import createSVG from './createSVG';

const GrundlagenIcon = ({style}) => (
  <path style={style} d="M1 25h4.7m0-4.7h4.7m0-4.7h4.7m0-4.7h4.7m0-4.7h4.7M5.7 25v-4.7m4.7 0v-4.7m4.7 0v-4.7m4.7 0V6.2m4.7 0V1.5" stroke="#7D7D7D" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
);

export default createSVG(GrundlagenIcon);
